import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Image from "components/Elements/Image/Image.tsx";
import config from "config";
import getEnsureLocalhostPort from "helpers/getEnsureLocalhostPort.ts";
import { useContent } from "contexts/contentContext/contentContext.js";

import "./Button.scss";

const getAlt = (img) => img.alt || img.title;

export const ButtonA = ({
  children,
  img,
  title,
  buttonClass,
  page,
  ...rest
}) => {
  const { getPath } = useContent();
  const classes = getClassName(rest, buttonClass);
  const {
    xs,
    small,
    medium,
    fullwidth,
    blank,
    large,
    white,
    close,
    roundicon,
    red,
    gray,
    green,
    ...props
  } = rest;

  const baseUrl = getEnsureLocalhostPort(config.baseurl);
  const href = page ? `${baseUrl}${getPath()}${page}` : "";

  return (
    <a
      disabled={props.disabled}
      type={rest.type === "cancelButton" ? "button" : "submit"}
      href={href}
      {...props}
      className={classes}
    >
      {title || children}
      {img ? <Image src={img.src} title={img.title} alt={getAlt(img)} /> : null}
    </a>
  );
};

export const ButtonAccessability = ({
  children,
  onClick,
  buttonClassName = "",
  title = "",
  disabled = false,
  elemRef,
  ...rest
}) => {
  const classes = classNames(["accesability-button", buttonClassName]);
  return (
    <button
      onClick={onClick}
      className={classes}
      title={title}
      disabled={disabled}
      ref={elemRef}
      {...rest}
    >
      {children}
    </button>
  );
};

const Button = ({
  children,
  img = null,
  title = "",
  buttonClass = "",
  ...rest
}) => {
  const classes = getClassName(rest, buttonClass);
  const {
    xs,
    small,
    medium,
    fullwidth,
    blank,
    large,
    white,
    close,
    roundicon,
    red,
    gray,
    green,
    ...props
  } = rest;
  return (
    <button
      disabled={props.disabled}
      type={rest.type === "cancelButton" ? "button" : "submit"}
      {...props}
      className={classes}
    >
      {title || children}
      {img ? <Image src={img.src} title={img.title} alt={getAlt(img)} /> : null}
    </button>
  );
};

Button.propTypes = {
  roundicon: PropTypes.bool,
  fullwidth: PropTypes.bool,
  xs: PropTypes.bool,
  small: PropTypes.bool,
  large: PropTypes.bool,
  medium: PropTypes.bool,
  blank: PropTypes.bool,
  transparent: PropTypes.bool,
  close: PropTypes.bool,
  red: PropTypes.bool,
  gray: PropTypes.bool,
  green: PropTypes.bool,
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
};

function getClassName(props, buttonClass) {
  const classes = ["jm-button"];

  if (props.className) classes.push(props.className);
  if (props.fullwidth) classes.push("full-width-button");
  if (props.xs) classes.push("xs-button");
  if (props.small) classes.push("small-button");
  if (props.medium) classes.push("medium-button");
  if (props.large) classes.push("large-button");
  if (props.blank) classes.push("blank-button");
  if (props.transparent) classes.push("transparent-button");
  if (props.white) classes.push("white-button");
  if (props.roundicon) classes.push("round-icon-button");
  if (props.green) classes.push("green-background");
  if (props.red) classes.push("red-background");
  if (props.gray) classes.push("gray-background");
  if (props.disabled) classes.push("disabled-button");
  if (props.close) classes.push("close-button");
  if (buttonClass) classes.push(buttonClass);
  return classNames(classes);
}
export default Button;
